<template>
  <div class="card">
      <div class="card-header bg-transparent text-left">
        <div class="row">
            <div class="col-md-6 col-12 text-center text-md-left">
                <strong>
                    {{periodText}}
                </strong>
            </div>
            <div class="col-md-4 col-10 text-left text-md-right">
                <strong>Total: </strong> {{format(total)}}
            </div>
            <div class="col-2 text-right">
                <font-awesome-icon icon="sync" @click="updateData()" rel="tooltip" title="Atualizar dados do gráfico" role="button" />
            </div>
        </div>
      </div>

      <div class="card-body">
          <sales 
            v-if="isLoading"
            :type="type"
            :options="options"
            :chart-data="chartdata"
          />
          <font-awesome-icon v-else icon="spinner" size="2x" spin  />
      </div>

      <div class="card-footer bg-transparent" v-if="pShowPeriod" >
          <div class="row" >
              <div class="col-md-12 text-center text-md-right" >
                <div class="btn-group" role="group" aria-label="Basic example">
                  <!-- <button type="button" v-bind:class="[active == 0 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('hour', 1)" class="btn btn-sm">Hoje</button> -->
                  <button type="button" v-bind:class="[active == 1 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('day', 7)" class="btn btn-sm">7 Dias</button>
                  <button type="button" v-bind:class="[active == 2 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('day', 15)"  class="btn btn-sm">15 Dias</button>
                  <button type="button" v-bind:class="[active == 3 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('day', 30)"  class="btn btn-sm">30 Dias</button>
                  <button type="button" v-bind:class="[active == 4 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('month', 3)" class="btn btn-sm">3 Meses</button>
                  <button type="button" v-bind:class="[active == 5 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('month', 6)"  class="btn btn-sm">6 Meses</button>
                  <button type="button" v-bind:class="[active == 6 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="changeType('month', 12)"  class="btn btn-sm">12 Meses</button>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
    import sales from '@/components/graphs/revenuesPerPeriod.vue'
    export default {
        name: 'homeRevenues',
        props: [
          'height',
          'pShowPeriod'
        ],
        components:{
          sales
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        data(){
          return {
            total: 0,
            isLoading: false,
            active: 1,
            period: 7,
            type: 'day',
            periodText: 'Faturamento dos últimos 7 Dias',
            chartdata: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {

                    }
                }
            }
          }
        },
        methods: {
            updateData: function(){
                let url
                this.isLoading = false
                
                if(this.type == 'day'){
                    url = server + 'graficos/vendas/periodo/dias/' + this.period
                }else if(this.type == 'month'){
                    url = server + 'graficos/vendas/' + this.period + '/' + this.type
                }else{
                    url = server + 'graficos/vendas/periodo/dias/' + this.period
                }
                fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        let data = responseJSON.response
                        let labels = []
                        let values = []

                        this.chartdata.labels = []
                        this.chartdata.datasets = []
                        this.total = 0

                        for (let index = 0; index < data.length; index++) {
                            const element = data[index];
                            if(this.type == 'month'){
                                switch (parseInt(element.PERIODO)) {
                                    case 1:
                                        labels.push('Jan / ' + element.ANO)
                                        break;
                                    case 2:
                                        labels.push('Fev / ' + element.ANO)
                                        break;
                                    case 3:
                                        labels.push('Mar / ' + element.ANO)
                                        break;
                                    case 4:
                                        labels.push('Abr / ' + element.ANO)
                                        break;
                                    case 5:
                                        labels.push('Mai / ' + element.ANO)
                                        break;
                                    case 6:
                                        labels.push('Jun / ' + element.ANO)
                                        break;
                                    case 7:
                                        labels.push('Jul / ' + element.ANO)
                                        break;
                                    case 8:
                                        labels.push('Ago / ' + element.ANO)
                                        break;
                                    case 9:
                                        labels.push('Set / ' + element.ANO)
                                        break;
                                    case 10:
                                        labels.push('Out / ' + element.ANO)
                                        break;
                                    case 11:
                                        labels.push('Nov / ' + element.ANO)
                                        break;
                                    case 12:
                                        labels.push('Dez / ' + element.ANO)
                                        break;
                                    default:
                                        labels.push('Mês / ' + element.ANO)
                                        break;
                                }
                            }else if(this.type == 'day'){
                                labels.push(element.EMISSAO)
                            }else{
                                labels.push(element.PERIODO)
                            }
                            values.push(element.TOTAL_LIQUIDO)
                            this.total = parseFloat(this.total) + parseFloat(element.TOTAL_LIQUIDO)
                        }

                        this.chartdata.labels = labels
                        this.chartdata.datasets.push({
                            label: 'Valor',
                            backgroundColor: '#f87979',
                            data: values
                        })

                        this.options.tooltips.callbacks.label = function(tooltipItem, data){
                            const formatter = new Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                                minimumFractionDigits: 2
                            })
                            return  'Valor ' + formatter.format(data.datasets[0].data[tooltipItem.index])
                        }
                        this.isLoading = true
                        
                    })
                    .catch(error => (console.log(error)));
            },
            changeType: function(type, period){
                if (type == 'day'){
                    if(period == 7){
                        this.period = period
                        this.type = type
                        this.active = 1
                        this.periodText = 'Faturamento dos últimos 7 Dias'
                    }else if(period == 15){
                        this.period = period
                        this.type = type
                        this.active = 2
                        this.periodText = 'Faturamento dos últimos 15 Dias'
                    }else{
                        this.period = period
                        this.type = type
                        this.active = 3
                        this.periodText = 'Faturamento dos últimos 30 Dias'
                    }
                }else if (type == 'month'){
                    if(period == 3){
                        this.period = period
                        this.type = type
                        this.active = 4
                        this.periodText = 'Faturamento dos últimos 3 Meses'
                    }else if(period == 6){
                        this.period = period
                        this.type = type
                        this.active = 5
                        this.periodText = 'Faturamento dos últimos 6 Meses'
                    }else{
                        this.period = period
                        this.type = type
                        this.active = 6
                        this.periodText = 'Faturamento dos últimos 12 Meses'
                    }
                }else{
                  this.period = period
                  this.type   = type
                  this.active = 0
                  this.periodText = 'Faturamento de hoje'   
                }

                this.updateData()
            },
            format: function(value){
              const formatter = new Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2
              })

              return formatter.format(value)
            }
        },
        mounted(){
          this.updateData()
        }
    }
</script>